export const contextReferral = {
    title: "Aucun filleul | Un filleul | {count} filleuls",
    'no-godchild': "Aucun filleul pour le moment."
}